// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PromoCodeBulkGenerateResponse

import { hydratePromoCode, type PromoCode, type PromoCodeApiResponse } from './promoCode.gen';

export type PromoCodeBulkGenerateApiResponse = {
	items: PromoCodeApiResponse[];
};

export type PromoCodeBulkGenerate = {
	items: PromoCode[];
};

export function hydratePromoCodeBulkGenerate(data: PromoCodeBulkGenerateApiResponse): PromoCodeBulkGenerate {
	return {
		...data,
		items: data.items.map(hydratePromoCode),
	};
}